"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useHover(cb) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var ref = (0, _react.useRef)(null);

  var handleMouseOver = function handleMouseOver(event) {
    var shouldHover = true;

    if (cb) {
      shouldHover = cb(event) !== false;
    }

    setValue(shouldHover);
  };

  var handleMouseOut = function handleMouseOut() {
    return setValue(false);
  };

  (0, _react.useEffect)(function () {
    var node = ref.current;

    if (node) {
      node.addEventListener("mouseenter", handleMouseOver);
      node.addEventListener("mouseleave", handleMouseOut);
      return function () {
        node.removeEventListener("mouseenter", handleMouseOver);
        node.removeEventListener("mouseleave", handleMouseOut);
      };
    }
  }, [ref.current] // Recall only if ref changes
  );
  var returnVal = [ref, value];
  return returnVal;
}

var _default = useHover;
exports["default"] = _default;